/* 
  HOWITWORKS 
  
  Welcome to Vilio-vue! I'm going to add a bunch of comment blocks with the name "HOWITWORKS" to try and document the entire application. Starting, CTRL+F for "HOWITWORKS", then follow each of the HOWITWORKS blocks and hopefully everything will make sense. 
*/

window.VERSION = VERSION;
console.log('Version:', window.VERSION);

// Polyfills
import 'babel-polyfill'

// CSS Imports - IMPROVE: Having this load with the scripts will cause the page to not have any styles until the JS loads
import('./css/nouislider.css');
import('./css/materialdesignicons.min.css');
import('../node_modules/vuetify/dist/vuetify.min.css');
import('./css/webkit-scrollbar.css');

// Remote Dependencies
import Vue              from 'vue'
import VueRouter        from 'vue-router'
import Vuetify          from 'vuetify'
import moment           from 'moment'
import { detect }       from 'detect-browser';
import vueSmoothScroll  from 'vue-smoothscroll'
import debounce         from 'v-debounce';

window.Vue              = Vue;
window._                = require('lodash');
window.moment           = moment;
window.browserDetect    = detect();

// Local Dependencies
import appDefault       from './app.js';          // HOWITWORKS - This file is commented with more HOWITWORKS comment blocks
import vmRouter         from './router.js';       // HOWITWORKS - This file is commented with more HOWITWORKS comment blocks
import regex            from './scripts/regex.js' // Collection of Regular Expressions used often
import cmps             from './components.js';   // Collection of all Components used
import ListModel        from './scripts/list';    // Model for automating a lazy loading list
import errors           from './scripts/error'    // Model for front end errors

import Filters          from './global/filters.js'   // Collection of filters to be piped into string interpolations {{ someProp | prettierFilter }}
// import Directives       from './global/directives.js' // Directives globally accessible (none right now)

window.ERRORS           = errors;
window.regex            = regex;
window.ListModel        = ListModel;

// Import Store
import { store }        from './store/store.js'   // HOWITWORKS - This has more HOWITWORKS comments inside
import { mapGetters }   from 'vuex'

// Import Smooth Scroll
Vue.use(vueSmoothScroll);

// Initialize Vuetify
Vue.use(Vuetify, {
  theme: {
    primary : '#009688',
    accent  : '#ffeb3b',
    error   : '#D00',
    success : '#4CAF50',
    info    : '#757575'
  }
});

// Initialize Router
const router = vmRouter.initRouter(VueRouter, cmps);
Vue.use(VueRouter);

// Dispatch Event
window.dispatch = function (name, data) {
      
  document.dispatchEvent(
    new CustomEvent(name, {
      detail: data
    })
  );
}

// Register Vue Components - HOWITWORKS: This will register all Components into Vue, changing any CamelCase name to kebab-case, and adding the prefix "vo-". For example, "TicketChat" becomes "vo-ticket-chat", and can be created in HTML with <vo-ticket-chat></vo-ticket-chat>.

for (var key in cmps) {
  var name = 'vo-' + key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  Vue.component(name, cmps[key]);
}

/* 
  HOWITWORKS

  This one is real important. As mentioned in app.js, if we want to manipulate our appData with access to two-way binding, computed properties, watchers, global methods, etc, we want to define them inside a Vue component. AppData will be a component that is defined just for that.
*/

import appDataCmp from './appDataCmp.js' // HOWITWORKS - This file is commented with more HOWITWORKS comment blocks

// HOWITWORKS - Initialize AppData and store it on window.AppData so that we have global access to our AppData features (app, router, store, everything!) (ノ‥)ノ
window.AppData = appDataCmp({
  store,
  router,
  appDefault
});


// Global Mixin to give all Components access to the App property, and some other functions we may want to have quick access to
import globalMixin from './globalMixin.js' // HOWITWORKS - This file is commented with more HOWITWORKS comment blocks
Vue.mixin(globalMixin({
  mapGetters,
  store,
  router,
  directives: {debounce}
}))

// HOWITWORKS: Finally, we'll create the main Vue instance. When App.vue calls it's "beforeCreated" hook, the fun begins. Now that everything is initialized, the rest of the components are much easier to understand, and very easy to work with. Continue to App.vue to see how the front end is displayed.

window.vm = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(cmps.App)
});


// WEBPACK FOOTER //
// ./src/main.js